import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { createBrowserHistory } from "history";

import "assets/plugins/nucleo/css/nucleo.css";
// import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-react.scss";

import AdminLayout from "./layouts/Admin.jsx";
import ConcessionariaLayout from "./layouts/Concessionaria.jsx";
import FiscalLayout from "./layouts/Fiscal.jsx";
import AuthLayout from "./layouts/Auth.jsx";
import OperadorLayout from "./layouts/Operador.jsx";
import MapaOrdem from "./layouts/MapaOrdem.jsx";
import { AlertasProvider } from "context/AlertasContext.jsx";

const history = createBrowserHistory();

ReactDOM.render(
  <AlertasProvider>
    <BrowserRouter history={history}>
      <Switch>
        <Route path="/admin" render={props => <AdminLayout {...props} />} />
        <Route path="/concessionaria" render={props => <ConcessionariaLayout {...props} />} />
        <Route path="/fiscal" render={props => <FiscalLayout {...props} />} />
        <Route path="/mapaordem" render={props => <MapaOrdem {...props} />} />
        <Route path="/auth" render={props => <AuthLayout {...props} />} />
        <Route path="/operador" render={props => <OperadorLayout {...props} />} />
        <Redirect from="/" to="/auth" />
      </Switch>
    </BrowserRouter>
  </AlertasProvider>,
  document.getElementById("root")
);
